// extracted by mini-css-extract-plugin
export default {"wrapper":"Kga","container":"Lga","box":"Mga","title":"Nga","rdwrap":"Oga","rditem":"Pga","rdimage":"Qga","name":"Rga","heading":"Sga","text":"Tga","guarantee":"Uga","chatbox":"Vga"};
    if(module.hot) {
      // 1738836199280
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  